<div class="claim-card" [ngClass]="{'selected': isSelected}">       
    <div class="uitk-card-body">
      <div class="card-heading-section">
        <div class="left-info">
          <div class="info-item claim-id-item">
            <span class="label">Claim ID:</span>
            <span class="value">{{ claimDetail.claimId }}</span>
          </div>
          <div *ngIf="getStatusDisplay(claimDetail?.medClmPrcsStateLst?.[0]?.prcsStatusNm) !== 'ORIGINAL'" class="info-item target-claim-item">
            <span class="label">Target Claim ID:</span>
            <span class="value">{{claimDetail?.targetClmId}}</span>
          </div>
        </div>
        
        <div class="right-status">
          <div class="info-item">
            <span class="label">Claim Received Date:</span>
            <span class="value">{{ claimDetail?.medClmPrcsStateLst?.[claimDetail?.medClmPrcsStateLst?.length - 1]?.recievedDateTime }}</span>
          </div>
          <div class="info-item">
            <span class="status value">{{getStatusDisplay(claimDetail?.medClmPrcsStateLst?.[0]?.prcsStatusNm)}}</span>
          </div>
        </div>
      </div>
      <hr class="break-line">

      <div class="uitk-c-table--responsive">
        <table
          uitkTable
          [dataSource]="dataSource"
          id="claim-detail-card-table"
          class="uitk-c-table"
          aria-describedby="Claim-detail"
        >
          <thead class="uitk-c-table__head">
            <tr>
              <ng-container *ngFor="let column of columns; let i = index" class="label">
                <th
                  *ngIf="!column.hideColumn"
                  [column]="column.id"
                  [ngStyle]="{ minWidth: column?.minWidth }"
                  [class.text-right]="column.id === 'prcsStateNm'"
                  [class.middle-text]="column.id === 'recievedDateTime'"
                  
                >
                  {{ column.label }}
                </th>
              </ng-container>
            </tr>
          </thead>
          <tbody id="row-data" class="uitk-c-table__body">
              <ng-container *uitkTableRowBody="let rowData">
                <tr class="uitk-c-table__row clickable-row">
                  <ng-container *ngFor="let col of columns; let i = index">
                    <td [class.text-right]="col.id === 'prcsStateNm'">
                      <ng-container>
                        <span>
                          {{ getDisplayValue(col.id, rowData[col.id]) }}
                        </span>
                      </ng-container>
                    </td>
                  </ng-container>
                </tr>
              </ng-container>
          </tbody>
        </table>
    </div>
    <!-- Conditionally Render View Audit Button -->
    <div *ngIf="hasAuditData()" class="view-audit" (click)="toggleAudit()">
      <a>
        {{ isAuditExpanded ? 'View Audit' : 'View Audit' }}
        <strong>
          <!-- <i
            class="uitk-icon view-audit-arrow"
            [ngClass]="{
              'uitk-icon-arrow_down': !isAuditExpanded,
              'uitk-icon-arrow_up': isAuditExpanded
            }"
          ></i> -->
           <uitk-icon
          *ngIf="!isAuditExpanded"
          class="view-audit-arrow"
          iconName="expand_more"
           title=" "
          ></uitk-icon>
          <uitk-icon
          *ngIf="isAuditExpanded"
          class="view-audit-arrow"
          iconName="expand_less"
          title=" "
         ></uitk-icon>

        </strong>
      </a>
    </div>
        <div [hidden]="!isAuditExpanded" class="expanded-audit-section">
            <table 
                uitkTable
               [dataSource]="claimAudit"
               id="claim-detail-audit-card-table"
               aria-describedby="Claim-detail"
               class="audit-table">
               <colgroup>
                <col class="audit-col-small">
                <col class="audit-col-middle">
                <col class="audit-col-large1">
                <col class="audit-col-large2">
              </colgroup>
              <thead class="uitk-c-table__head">
                <tr>
                  <th></th>
                  <th></th>
                  <th class="highlighted-header raised-header">PREVIOUS VALUE</th>
                  <th class="highlighted-header raised-header">UPDATED VALUE</th>
                </tr>
                <tr class="audit-header">&nbsp;</tr>
                
              </thead>
              
              <tbody id="row-data" class="uitk-c-table__body">
                <ng-container *uitkTableRowBody="let rowData; let j = index">
                  <tr>
                  <ng-container *ngFor="let column of auditColumns; let i = index" class="label">
                    <th *ngIf="!column.hideColumn" [column]="column.id" [ngStyle]="{ minWidth: column?.minWidth }">
                      <div *ngIf="(i == 0 || i == 1) && j == 0">
                          {{ column.label }}
                      </div>
                       <div *ngIf="i == 2 || i == 3">
                          {{ getAuditDisplayKey(rowData) }}
                      </div> 
                    </th>
                  </ng-container>
                </tr>
                  <tr class="uitk-c-table__row clickable-row">
                    <ng-container *ngFor="let col of auditColumns; let i = index">
                      <td class="preserve-line">
                        <ng-container>
                          <span class="path-text">
                            {{ getAuditDisplayValue(col.id, rowData) }}
                          </span>
                        </ng-container>
                      </td>
                      
                    </ng-container>
                    
                  </tr>
                  <tr class="divider-row">
                 </tr>
                  
                </ng-container>
              </tbody>
              
            </table>
        </div>
      </div>
    </div>
